import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';
import {
	borderOutline,
	brandPrimary,
	brandPrimaryText,
	darkGrayFontColor,
	titles,
	white,
} from '../../../../../web/styles/colors';
import { baseStyleSheet } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		marginBottom: THEME.spacing.sm,
	},
	headerTitle: {
		...baseStyleSheet.fontBold,
		color: titles,
		fontSize: THEME.typography.fontSizes.lg,
		margin: 0,
	},
	headerDescription: {
		color: darkGrayFontColor,
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: 1.3,
		margin: 0,
	},
	filtersSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		marginBottom: 8,
	},
	searchInputWrapper: {
		width: '100%',
	},
	searchInput: {
		fontSize: THEME.typography.fontSizes.sm,
		minHeight: 32,
	},
	searchIcon: {
		flexShrink: 0,
	},
	filterPills: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
	},
	sortRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		justifyContent: 'space-between',
	},
	sortSelect: {
		fontSize: THEME.typography.fontSizes.sm,
		minHeight: 32,
		paddingLeft: 12,
		paddingRight: 12,
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	card: {
		backgroundColor: white,
		border: `1px solid ${borderOutline}`,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: 12,
	},
	cardClickable: {
		cursor: 'pointer',
		':hover': {
			borderColor: THEME.colors.primary.main,
		},
	},
	cardHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: 8,
	},
	ratingValueContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
	},
	authorName: {
		color: brandPrimaryText,
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: 600,
	},
	ratingValue: {
		fontSize: THEME.typography.fontSizes.sm,
	},
	cardHeaderLeft: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	author: {
		...baseStyleSheet.fontBold,
		color: titles,
		fontSize: THEME.typography.fontSizes.sm,
	},
	date: {
		color: darkGrayFontColor,
		fontSize: THEME.typography.fontSizes.sm,
	},
	ratingRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
	},
	reviewText: {
		color: darkGrayFontColor,
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: 1.4,
		margin: 0,
		overflow: 'hidden',
		WebkitLineClamp: 3,
		WebkitBoxOrient: 'vertical',
	},
	emptyState: {
		color: darkGrayFontColor,
		fontSize: THEME.typography.fontSizes.sm,
		padding: THEME.spacing.lg,
		textAlign: 'center',
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: THEME.spacing.lg,
	},
	list: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	loadingMore: {
		display: 'flex',
		justifyContent: 'center',
		padding: THEME.spacing.md,
	},
	testimonialModal: {},

	testimonialModalOverlay: {
		alignItems: 'center',
		background: 'rgba(0, 0, 0, 0.5)',
		display: 'flex',
		inset: 0,
		height: '100%',
		justifyContent: 'center',
		position: 'fixed',
		width: '100%',
		zIndex: 5,
	},
	testimonialModalContent: {
		backgroundColor: white,
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		width: '100%',
	},
	testimonialModalHeader: {
		alignItems: 'center',
		backgroundColor: brandPrimary,
		display: 'flex',
		flex: '0 0 50px',
		paddingLeft: THEME.spacing.md,
		paddingRight: THEME.spacing.md,
	},
	testimonialModalHeaderTitle: {
		boxSizing: 'border-box',
		color: white,
		flex: 1,
		fontSize: THEME.typography.fontSizes.lg,
		margin: 0,
		padding: 0,
		textAlign: 'center',
	},
	testimonialModalBody: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		overflow: 'auto',
	},
	containerStyles: {
		backgroundColor: THEME.colors.background.light,
	},
	builderStyles: {
		// very specific width to match the width of the preview
		width: 536,
	},
});
